import { render, staticRenderFns } from "./Regulations.vue?vue&type=template&id=1af32e31&scoped=true&"
import script from "./Regulations.vue?vue&type=script&lang=js&"
export * from "./Regulations.vue?vue&type=script&lang=js&"
import style0 from "./Regulations.vue?vue&type=style&index=0&id=1af32e31&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af32e31",
  null
  
)

export default component.exports